export default function QuestionnaireHeader() {
    return (
        <p className="p-text fs-6 ps-4">
            Provide responses to each question to complete the questionnaire.
            Our team will contact you if clarification is required.
            For any additional questions, please connect with your assigned point of contact.
        </p>
    )
}
